<app-grid-container [padding]="'0'" [columns]="'5fr 2fr'" [colGap]="'0'" [rowGap]="'1rem'" [theme]="UiThemes.Light">
  <div class="slide-selector">
    <h6>{{ nameText }}</h6>
    <div #rangeSlider></div>
  </div>
  <div class="result">
    <div *ngIf="staticDisplay; else inputDisplay">
      <h4>{{ sliderResultView / divisor }} {{ measure }}</h4>
    </div>
    <ng-template #inputDisplay>
      <input
        type="number"
        [value]="sliderResultView / divisor"
        (change)="sliderInput($event)"
        step="0.5"
        [min]="minValue / divisor"
        [max]="maxValue / divisor" >
        {{ measure }}
      </ng-template> 
  </div>
</app-grid-container>
